<template>
  <div>
    <div class="categories-container">
      <h4 class="categories-title">Categories</h4>

      <b-card-group deck class="categories-deck">
        <b-card
          title="Show All"
          :img-src="premiumShowAllImg"
          img-alt="Show All"
          img-top
          class="text-center"
          @click="$emit('navigate', 'PremiumShowAllCards'); categorySelected('ShowAll');"
        >
        </b-card>
        <b-card
          title="Masterclasses"
          :img-src="masterclassesImg"
          img-alt="Masterclasses"
          img-top
          class="text-center"
          @click="$emit('navigate', 'PremiumShowAllCards'); categorySelected('Masterclasses');"
        >
        </b-card>
        <b-card
          title="Special Guests"
          :img-src="specialGuestsImg"
          img-alt="Special Guests"
          img-top
          class="text-center"
          @click="$emit('navigate', 'PremiumShowAllCards'); categorySelected('SpecialGuests');"
        >
        </b-card>
        <b-card
          title="Seasonal Gifts"
          :img-src="seasonalGiftsImg"
          img-alt="Seasonal Gifts"
          img-top
          class="text-center"
          @click="$emit('navigate', 'PremiumShowAllCards'); categorySelected('SeasonalGifts');"
        >
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import premiumShowAll from "@/assets/images/centre/premium/PremiumShowAll.png";
import masterclasses from "@/assets/images/centre/premium/Masterclasses.png";
import specialGuests from "@/assets/images/centre/premium/SpecialGuests.png";
import seasonalGifts from "@/assets/images/centre/premium/SeasonalGifts.png";


export default {
  name: "PremiumCategoriesCards",
  components: { },
  data() {
    return {
      premiumShowAllImg: premiumShowAll,
      masterclassesImg: masterclasses,
      specialGuestsImg: specialGuests,
      seasonalGiftsImg: seasonalGifts,
    }
  },
  methods: {
    categorySelected(category) {
      //UPDATING CATEGORY
      this.$root.$emit(
        "premium-category",
        category
      );
      this.$router.push({
        name: "Premium",
        query: { category: category },
    }).catch(()=>{});
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.categories-title {
  font-weight: 700;
  margin-bottom: 3rem;
}

div.card {
  border: none;
  display: inline-block;
  transition: all .2s ease-in-out;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}

.card-img-top {
  border-radius: 50%;
  vertical-align: middle;
  background-color: $light-gray;
  width: 160px;
  height: 160px;
  filter: drop-shadow(0 0.5rem 0.25rem rgba(0, 0, 0, 0.2));
}

h4.card-title {
  font-size: 16px;
}

@media screen and (max-width: 767px) {
  div.card-deck.categories-deck {
    display: flex;

    .card {
      margin-bottom: 0;
    }

    .card-img-top {
      max-width: 100%;
      height: auto;
      padding: 0.3rem;
      background-color: transparent;

    }

    h4.card-title {
      font-size: 10px;
    }
  }
}
</style>
